import type { ScopedThreadRef } from "@cmmd-forge/contracts";

import type { DraftId } from "../draftId";

type ComposerTarget = DraftId | ScopedThreadRef;

export function seedThreadComposerContext(input: {
  readonly target: ComposerTarget;
  readonly prompt: string | null | undefined;
  readonly existingPrompt?: string | null | undefined;
  readonly replaceExistingPrompt?: string | null | undefined;
  readonly autoSubmit?: boolean;
  readonly setPrompt: (target: ComposerTarget, prompt: string) => void;
  readonly setPendingAutoSubmit: (target: ComposerTarget, value: boolean) => void;
}): void {
  const prompt = input.prompt?.trim();
  const existingPrompt = input.existingPrompt?.trim();
  const replaceExistingPrompt = input.replaceExistingPrompt?.trim();
  if (!prompt || (existingPrompt && existingPrompt !== replaceExistingPrompt)) {
    return;
  }

  input.setPrompt(input.target, prompt);
  if (input.autoSubmit === true) {
    input.setPendingAutoSubmit(input.target, true);
  }
}
